module.exports = __webpack_public_path__ + "26c2f65830f11edb31069f87270d4fe7.svg";